import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <div
    className="flex items-center gap-3 text-[11px] font-semibold tracking-[0.25em] uppercase mb-5"
    style={{ color: "var(--brass)" }}
  >
    <span className="h-px w-8" style={{ background: "var(--brass)" }} />
    {children}
  </div>
);
